<template>
  <div v-if="visible" :class="classes">
    <div v-if="accessible" role="status" aria-live="polite" aria-busy="true">
      <i class="icon -loading" aria-label="Loading..." />
    </div>
    <div v-else>
      <i aria-hidden="true" class="icon -loading" />
    </div>
  </div>
</template>

<script>
// @flow
export default {
  name: 'Loader',
  props: {
    // switched to v-if from class
    visible: {
      type: Boolean,
      required: true,
    },

    accessible: {
      type: Boolean,
      default: true,
    },

    // class name override support
    classes: {
      type: String,
      default: 'loader active',
    },
  },
}
</script>
